import axios, { AxiosError } from 'axios';
import { assign, createMachine } from 'xstate';

import { API_ENDPOINTS } from 'utils/constants';
import { SSOProvider } from 'utils/types';

export const machine = createMachine(
  {
    predictableActionArguments: true,
    preserveActionOrder: true,
    tsTypes: {} as import('./machine.typegen').Typegen0,
    schema: {
      events: {} as {
        type: 'Search';
        value: string;
      },
      context: {} as {
        data: SSOProvider | null;
        error: string | null;
        inputValue: string;
      },
      services: {} as {
        fetchProviderData: { data: SSOProvider | null };
      }
    },
    id: 'SSO Page',
    initial: 'idle',
    on: {
      Search: {
        target: 'delayedSearch',
        actions: ['setInputValue']
      }
    },
    states: {
      idle: {
        always: {
          cond: 'hasInputValue',
          target: 'searching'
        }
      },
      ready: {
        on: {
          Search: {
            target: 'delayedSearch',
            actions: ['setInputValue']
          }
        }
      },
      delayedSearch: {
        on: {
          Search: {
            target: 'delayedSearch',
            actions: ['setInputValue']
          }
        },
        after: {
          500: { target: 'searching' }
        }
      },
      searching: {
        invoke: {
          id: 'search',
          src: 'fetchProviderData',
          onDone: {
            target: 'ready',
            actions: ['setData']
          },
          onError: {
            target: 'ready',
            actions: 'setError'
          }
        }
      }
    }
  },
  {
    guards: {
      hasInputValue: (context) => !!context.inputValue
    },
    actions: {
      setInputValue: assign((_, event) => ({ inputValue: event.value })),
      setData: assign((_, event) => ({
        data: event.data,
        error: null
      })),
      setError: assign((_, event) => ({
        data: null,
        error: (event.data as AxiosError<{ error: string }>).response?.data
          ?.error
      }))
    },
    services: {
      fetchProviderData: async (context) => {
        if (!context.inputValue) {
          return Promise.resolve(null);
        }

        const { data } = await axios.get<SSOProvider>(
          API_ENDPOINTS.SSO_PROVIDERS,
          {
            params: { q: context.inputValue }
          }
        );

        return data;
      }
    }
  }
);
